import { Outlet, useLocation } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { Col, Container, Image, Navbar, NavbarBrand, Offcanvas, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Logo from "images/logos/tonatrenujes.svg";
import HamburgerMenu from "images/icons/hamburger.svg";

import { Menu } from "components/Menu/Menu";
import { Footer } from "components/Footer";
import { CurrentStreak } from "components";
import CalendarWeeksLeft from "components/CalendarWeeksLeft/CalendarWeeksLeft";

import { useAppSelector } from "store/hooks";
import { getGrade } from "store/slices/user";

const Layout = () => {
  const [isShown, setIsShown] = useState(false);
  const { pathname } = useLocation();
  const { t } = useTranslation(["common"]);
  const grade = useAppSelector(getGrade);

  const handleClose = () => {
    setIsShown(false);
  };
  const handleShow = () => {
    setIsShown(true);
  };

  useEffect(() => {
    setIsShown(false);
  }, [pathname]);

  return (
    <>
      <nav className="navigation">
        <Navbar className="flex-sm-column w-100">
          <LinkContainer to="/">
            <NavbarBrand className={"mx-0 navigation__brand"}>
              <Logo />
              {/* Odznak jen maturantům; pod xs se navigace skládá do řádku a odznak by se do ní nevešel. */}
              {grade === "maturant" ? (
                <span className="navigation__grade d-none d-sm-inline-block">{t("gradeMaturita")}</span>
              ) : null}
            </NavbarBrand>
          </LinkContainer>

          <div className={"navigation__desktop"}>
            <CurrentStreak className="py-24px" isShort={true} />
            <Menu />
            <CalendarWeeksLeft />
          </div>

          <div className={"navigation__mobile pt-sm-60px"}>
            <CurrentStreak isShort={true} />
            <Button variant="light" onClick={handleShow} className={"btn-circular hamburger"}>
              <HamburgerMenu />
            </Button>
          </div>
        </Navbar>
      </nav>

      <Container fluid>
        <Row>
          <Col className={"col-main py-20px"} as={"main"}>
            <Outlet />
          </Col>
        </Row>

        <Row>
          <Col className={"col-main"}>
            <Footer />
          </Col>
        </Row>
      </Container>

      <Offcanvas show={isShown} onHide={handleClose} placement={"end"} className={"offcanvas-menu"}>
        <Offcanvas.Header closeButton />
        <Offcanvas.Body className="d-flex flex-column h-100">
          <Menu />
          <CalendarWeeksLeft />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Layout;
